import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { Dashboard } from "views/scenes";
import styles from "./style.module.scss";

export default class Routes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/:token" component={Dashboard} />
      </Switch>
    );
  }
}
